import React, {useEffect, useState} from "react";
import {parseColorInput} from "../../libs/colorPicker";

export function BaseColorInput({value, onChange}: {value: string; onChange: (value: string) => void}) {
  const [draft, setDraft] = useState(value);
  useEffect(() => {setDraft(value);}, [value]);
  return <input id="base-color" type="text" value={draft}
    onChange={(event) => {
      const text = event.target.value.trim();
      if (/^[0-9a-f]{0,6}$/i.test(text)) {
        setDraft(text);
        if (text.length === 3 || text.length === 6) onChange(text);
        return;
      }
      const hex = parseColorInput(text);
      if (hex) {setDraft(hex.slice(1)); onChange(hex.slice(1));}
    }}
    onBlur={() => setDraft(value)} className="base-color-input" placeholder="000" spellCheck={false} />;
}
